// extracted by mini-css-extract-plugin
module.exports = {"ProductDrawer":"ProductDrawer_ProductDrawer__12pz4","icon":"ProductDrawer_icon__2C-NB","info":"ProductDrawer_info__2gS8q"};